<template>
  <div ref="drawerBox">
    <a-table
        ref="listRef" :scroll="{y}"
        class="tableBox"
        :columns="columns"
        :data-source="list"
        rowKey="id"
        :pagination="false"
      >
        <template slot="name" slot-scope="text,record">
          {{overseasFlag == '1' ? (record.aliasName || text) : text}}
        </template>
        <span slot="uasge" slot-scope="text">{{text || text === 0 || text === '0' ? Number(text).toFixed(3) : null}}</span>
      </a-table>
  </div>
</template>
<script>
export default {
  props:{
    drwaerObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data(){
    return{
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      y: 500,
      columns:[
        {title: '原料代码',dataIndex: 'code',sorter: (a, b) => a.code - b.code,},
        {title: '原料类型',dataIndex: 'typeStr',sorter: (a, b) => a.typeStr.localeCompare(b.typeStr,'zh'),},
        {title: '原料名称',dataIndex: 'name',sorter: (a, b) => a.name.localeCompare(b.name,'zh'),scopedSlots: {customRender: 'name'},},
        {title: '工厂名称',dataIndex: 'factoryName',sorter: (a, b) => a.factoryName.localeCompare(b.factoryName,'zh'),},
        {title: '预估用量',dataIndex: 'uasge',sorter: (a, b) => a.uasge - b.uasge,scopedSlots: { customRender: 'uasge' },},
        {title: '重量单位',dataIndex: 'weightUnit'},
      ],
      list:[],
    }
  },
  mounted(){
    this.getList()
    this.y = this.$refs.drawerBox.offsetHeight - 100
  },
  methods:{
    getList(){
      let params = {
        forecastId: this.drwaerObj.id
      }
      this.$http.get('/nhf-app/productiondetail/formula/rawStatistics',{params}).then(res => {
        let {success,data} = res;
        if(success){
          // console.log(data)
          // data && data.map(el => {
          //   el.edit = false
          //   return el
          // })
          
          if(data.length > 0){
            let num = 0
            let weightUnit = data[0].weightUnit
            data && data.forEach(el => {
              num += Number(el.uasge || 0)
            })
            data.push({
              code: '合计',
              uasge: num,
              weightUnit
            })
          }
          this.list = data
        }
      })
    },
  }
}
</script>